import { FC } from 'react'

import { EmbroideryIconAsset } from '../../../types/graphql'
import { IconSelector } from '../forms/selectors/IconSelector'

import { IconGroupLabel } from './styles'

interface Props {
  name: string
  displayName: string
  images: EmbroideryIconAsset[]
  maxIconsPerRowMobile?: number | undefined
  onSelectIcon(iconImage: EmbroideryIconAsset): void
  productColorHex: string | undefined
  selectedImage: EmbroideryIconAsset | undefined
}

export const EmbroideryIconGroupSection: FC<Props> = ({
  name,
  displayName,
  images,
  maxIconsPerRowMobile,
  onSelectIcon,
  productColorHex,
  selectedImage,
}) => {
  const labelId = `icon-group-${name}`

  return (
    <>
      {displayName && <IconGroupLabel id={labelId}>{displayName}</IconGroupLabel>}
      <IconSelector
        images={images}
        labelId={labelId}
        maxIconsPerRowMobile={maxIconsPerRowMobile}
        onSelectIcon={onSelectIcon}
        selectedImage={selectedImage}
        productColorHex={productColorHex}
      />
    </>
  )
}
